import React from 'react';
import { User } from '../types';
import { getAvatarUrl } from '../utils/avatarUtils';
import { Trophy } from 'lucide-react';
import { SafeImage } from './common/SafeImage';

interface UserCardProps {
  user: User;
  rank: number;
  type: 'weekly' | 'monthly' | 'allTime';
}

const UserCard: React.FC<UserCardProps> = ({ user, rank, type }) => {
  const score = type === 'weekly' 
    ? user.weeklyScore 
    : type === 'monthly' 
      ? user.monthlyScore 
      : user.score;

  console.log('user', score);
  console.log('user', user);

  // Define trophy colors for top positions
  const getTrophyColor = (position: number) => {
    switch (position) {
      case 1: return 'text-amber-400'; // Gold
      case 2: return 'text-gray-300'; // Silver
      case 3: return 'text-amber-700'; // Bronze
      default: return 'text-slate-500';
    }
  };


  return (
    <div 
      className={`flex items-center p-4 mb-3 rounded-lg transition-all duration-300 ${
        rank <= 3 
          ? 'bg-slate-800 shadow-lg' 
          : 'bg-slate-900 hover:bg-slate-800'
      }`}
    >
      <div className="flex items-center justify-center w-8 h-8 mr-4">
        {rank <= 3 ? (
          <Trophy className={`w-6 h-6 ${getTrophyColor(rank)}`} />
        ) : (
          <span className="text-slate-400 font-semibold">{rank}</span>
        )}
      </div>
      
      <div className="h-12 w-12 rounded-full overflow-hidden mr-4 flex-shrink-0 border-2 border-slate-700">
        <SafeImage 
          src={getAvatarUrl((user as any).photoURL || (user as any).profilePhotoUrl || user.id || user.username)} 
          fallbackSeed={user.id || user.username}
          alt={user.username} 
          className="h-full w-full object-cover"
        />
      </div>
      
      <div className="flex-grow">
        <h3 className="font-medium text-white">{user.username}</h3>
        <p className="text-sm text-slate-400">
          {type === 'weekly' ? 'This week' : type === 'monthly' ? 'This month' : 'All time'}
        </p>
      </div>
      
      <div className="text-right">
        <p className={`font-bold ${rank <= 3 ? 'text-amber-400' : 'text-white'}`}>
          {score?.toLocaleString()}
        </p>
        <p className="text-xs text-slate-400">points</p>
      </div>
    </div>
  );
};

export default UserCard;